
/*
  This file is auto-generated and ignored by git.
  See the jsdocs-related scripts in package.json and pregenerate.js
*/

export default {
  "KButton": {
    "exportName": "default",
    "displayName": "KButton",
    "description": "The KButton component is used to trigger actions",
    "tags": {},
    "props": [
      {
        "name": "text",
        "mixin": {
          "name": "buttonMixin",
          "path": "buttonMixin.js"
        },
        "description": "Button label text",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "appearance",
        "mixin": {
          "name": "buttonMixin",
          "path": "buttonMixin.js"
        },
        "description": "Button appearance: `'raised-button'`, `'flat-button'`, or `'basic-link'`",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "'raised-button'"
        }
      },
      {
        "name": "appearanceOverrides",
        "mixin": {
          "name": "buttonMixin",
          "path": "buttonMixin.js"
        },
        "description": "Overrides that will modify the styles sent to `$computedClass` based on `appearance` prop",
        "type": {
          "name": "object"
        },
        "defaultValue": {
          "func": false,
          "value": "{}"
        }
      },
      {
        "name": "primary",
        "mixin": {
          "name": "buttonMixin",
          "path": "buttonMixin.js"
        },
        "description": "Show as primary rather than secondary style (for `'raised-button'` and `'flat-button'` appearance)",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "disabled",
        "description": "Whether or not button is disabled",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "type",
        "description": "HTML button `type` attribute (e.g. `'submit'`, `'reset'`)",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "'button'"
        }
      },
      {
        "name": "hasDropdown",
        "description": "Adds a dropdown arrow",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "icon",
        "description": "If provided, prepends a `KIcon` to the text in the button",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "iconAfter",
        "description": "If provided, appends an `KIcon` to the text in the button",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      }
    ],
    "events": [
      {
        "name": "click",
        "description": "Emitted when the button is triggered",
        "type": {
          "names": [
            "undefined"
          ]
        }
      }
    ],
    "slots": [
      {
        "name": "icon",
        "description": "Slot alternative to the `icon` prop"
      },
      {
        "name": "menu",
        "description": "Pass sub-components into the button, typically `KDropdownMenu`"
      },
      {
        "name": "default",
        "description": "Slot alternative to the `icon` prop"
      },
      {
        "name": "iconAfter",
        "description": "Slot alternative to the `iconAfter` prop"
      }
    ]
  },
  "KButtonGroup": {
    "displayName": "KButtonGroup",
    "description": "Used to create a consistently spaced horizontal set of buttons and/or links.\n\nKButtonGroup works with KButton, KIconButton, KRouterLink and KExternalLink and any <a> or <button> tags.\nin it's default slot.",
    "tags": {},
    "exportName": "default",
    "slots": [
      {
        "name": "default"
      }
    ]
  },
  "KExternalLink": {
    "exportName": "default",
    "displayName": "KExternalLink",
    "description": "KExternalLink creates a styled external link",
    "tags": {},
    "props": [
      {
        "name": "text",
        "mixin": {
          "name": "buttonMixin",
          "path": "buttonMixin.js"
        },
        "description": "Button label text",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "appearance",
        "mixin": {
          "name": "buttonMixin",
          "path": "buttonMixin.js"
        },
        "description": "Button appearance: `'raised-button'`, `'flat-button'`, or `'basic-link'`",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "'basic-link'"
        }
      },
      {
        "name": "appearanceOverrides",
        "mixin": {
          "name": "buttonMixin",
          "path": "buttonMixin.js"
        },
        "description": "Overrides that will modify the styles sent to `$computedClass` based on `appearance` prop",
        "type": {
          "name": "object"
        },
        "defaultValue": {
          "func": false,
          "value": "{}"
        }
      },
      {
        "name": "primary",
        "mixin": {
          "name": "buttonMixin",
          "path": "buttonMixin.js"
        },
        "description": "Show as primary rather than secondary style (for `'raised-button'` and `'flat-button'` appearance)",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "href",
        "description": "URL string",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "download",
        "description": "Specifies that the file is meant to be downloaded, not displayed in a separate tab.",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "openInNewTab",
        "description": "If provided, opens link in new tab and displays a \"pop out\" icon",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "icon",
        "description": "If provided, shows a KIcon in front of the text",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "iconAfter",
        "description": "If provided, shows a KIcon after the text",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      }
    ],
    "slots": [
      {
        "name": "icon",
        "description": "Slot alternative to the `icon` prop"
      },
      {
        "name": "default",
        "description": "Slot alternative to the `icon` prop"
      },
      {
        "name": "iconAfter",
        "description": "Slot alternative to the `icon` prop"
      }
    ]
  },
  "KIconButton": {
    "displayName": "KIconButton",
    "exportName": "default",
    "description": "",
    "tags": {},
    "props": [
      {
        "name": "icon",
        "description": "Name of icon to display",
        "type": {
          "name": "string"
        },
        "required": true
      },
      {
        "name": "appearance",
        "description": "Button appearance: `'raised-button'` or `'flat-button'`",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "'flat-button'"
        }
      },
      {
        "name": "color",
        "description": "Optional hex or rgb[a] color for the button background",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "disabled",
        "description": "Whether or not button is disabled",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "buttonType",
        "description": "HTML button `type` attribute (e.g. `'submit'`, `'reset'`)",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "'button'"
        }
      },
      {
        "name": "size",
        "description": "Button size: `'mini'`, `'small'`, `'regular'`, or `'large'`",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "'regular'"
        }
      },
      {
        "name": "ariaLabel",
        "description": "`aria-label` attribute",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "tooltip",
        "description": "Tooltip label",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "tooltipPosition",
        "description": "Tooltip position: `'top', 'right', 'bottom', 'left'`",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "'bottom'"
        }
      }
    ],
    "slots": [
      {
        "name": "menu",
        "description": "Pass sub-components into the button, typically `KDropdownMenu`"
      }
    ]
  },
  "KRouterLink": {
    "exportName": "default",
    "displayName": "KRouterLink",
    "description": "KRouterLink creates a styled router-link",
    "tags": {},
    "props": [
      {
        "name": "text",
        "mixin": {
          "name": "buttonMixin",
          "path": "buttonMixin.js"
        },
        "description": "Button label text",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "appearance",
        "mixin": {
          "name": "buttonMixin",
          "path": "buttonMixin.js"
        },
        "description": "Button appearance: `'raised-button'`, `'flat-button'`, or `'basic-link'`",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "'basic-link'"
        }
      },
      {
        "name": "appearanceOverrides",
        "mixin": {
          "name": "buttonMixin",
          "path": "buttonMixin.js"
        },
        "description": "Overrides that will modify the styles sent to `$computedClass` based on `appearance` prop",
        "type": {
          "name": "object"
        },
        "defaultValue": {
          "func": false,
          "value": "{}"
        }
      },
      {
        "name": "primary",
        "mixin": {
          "name": "buttonMixin",
          "path": "buttonMixin.js"
        },
        "description": "Show as primary rather than secondary style (for `'raised-button'` and `'flat-button'` appearance)",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "to",
        "description": "vue-router link object",
        "type": {
          "name": "object"
        },
        "required": true
      },
      {
        "name": "icon",
        "description": "If provided, shows a `KIcon` with the given name before the text",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "iconAfter",
        "description": "If provided, shows a `KIcon` with the given name after the text",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "replace",
        "description": "Use window.history.replaceState() so navigation will not leave history record",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      }
    ],
    "slots": [
      {
        "name": "icon",
        "description": "Optional slot as alternative to `icon` prop"
      },
      {
        "name": "default",
        "description": "Optional slot as alternative to `text` prop"
      },
      {
        "name": "iconAfter",
        "description": "Optional slot as alternative to `iconAfter` prop"
      }
    ]
  },
  "KFixedGrid": {
    "exportName": "default",
    "displayName": "KFixedGrid",
    "description": "Grid layout with a fixed number of columns",
    "tags": {},
    "props": [
      {
        "name": "numCols",
        "description": "The number of columns. Can be an integer between `2` and `12`",
        "type": {
          "name": "number|string"
        },
        "required": true
      },
      {
        "name": "gutter",
        "description": "The size of column gutters in pixels. If not provided, the gutter is set to `16px`\nif either window dimension is less than `600px`, and set to `24px` otherwise.",
        "type": {
          "name": "number|string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "gridStyle",
        "description": "EXPERIMENTAL: Extra styles to attach to the internal grid DOM node",
        "tags": {
          "ignore": [
            {
              "description": true,
              "title": "ignore"
            }
          ]
        },
        "type": {
          "name": "object"
        },
        "defaultValue": {
          "func": false,
          "value": "{}"
        }
      },
      {
        "name": "debug",
        "description": "Show gridlines for debugging purposes",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      }
    ],
    "slots": [
      {
        "name": "default",
        "description": "Children of a `KFixedGrid` must be `KFixedGridItem` components"
      }
    ]
  },
  "KFixedGridItem": {
    "exportName": "default",
    "displayName": "KFixedGridItem",
    "description": "Basic fixed grid item",
    "tags": {},
    "props": [
      {
        "name": "span",
        "description": "Number of grid columns that the item should span.\n\nIf not provided, the item will span the full width of the grid.",
        "type": {
          "name": "number|string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "alignment",
        "description": "Horizontal alignment of the item's contents. `'left'`, `'right'`,\nand `'center'` will set `text-align`. `'auto'` will set `dir=\"auto\"`\nfor user-generated content to support bidirectional text.",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "'left'"
        }
      }
    ],
    "slots": [
      {
        "name": "default",
        "description": "Contents of the grid item"
      }
    ]
  },
  "KGrid": {
    "exportName": "default",
    "displayName": "KGrid",
    "description": "Grid layout with a dynamic number of columns based on the current window width.\n\nThe grid will have 4 columns for small windows (width < 840px), 8 columns\nfor medium windows (840 px <= width < 960), and 12 columns for large windows\n(960px <=  width)",
    "tags": {},
    "props": [
      {
        "name": "gutter",
        "description": "The size of column gutters in pixels. If not provided, the gutter is set to `16px`\nif either window dimension is less than `600px`, and set to `24px` otherwise.",
        "type": {
          "name": "number|string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "gridStyle",
        "description": "EXPERIMENTAL: Extra styles to attach to the internal grid DOM node",
        "tags": {
          "ignore": [
            {
              "description": true,
              "title": "ignore"
            }
          ]
        },
        "type": {
          "name": "object"
        },
        "defaultValue": {
          "func": false,
          "value": "{}"
        }
      },
      {
        "name": "debug",
        "description": "Show gridlines for debugging purposes",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      }
    ],
    "slots": [
      {
        "name": "default",
        "description": "Children of a `KFixedGrid` must be `KGridItem` components"
      }
    ]
  },
  "KGridItem": {
    "exportName": "default",
    "displayName": "KGridItem",
    "description": "Responsive grid item used with KGrid.\n\nAccepts \"layout objects\" as props, which can define values for 'span',\n'alignment', or both.\n\nIf no span is defined for a particular layout, the item will span the full\nwidth of the grid.\n\nIf no alignment is defined for a particular layout, the item's contents\nwill be left-aligned. Set `alignment` to `'auto'` to set `dir=\"auto\"`\nfor user-generated content to support bidirectional text.",
    "tags": {},
    "props": [
      {
        "name": "layout",
        "description": "Default layout object, for all grid sizes",
        "type": {
          "name": "object"
        },
        "defaultValue": {
          "func": false,
          "value": "{}"
        }
      },
      {
        "name": "layout4",
        "description": "Layout object for small, 4-column layouts",
        "type": {
          "name": "object"
        },
        "defaultValue": {
          "func": false,
          "value": "{}"
        }
      },
      {
        "name": "layout8",
        "description": "Layout object for medium, 8-column layouts",
        "type": {
          "name": "object"
        },
        "defaultValue": {
          "func": false,
          "value": "{}"
        }
      },
      {
        "name": "layout12",
        "description": "Layout object for large, 12-column layouts",
        "type": {
          "name": "object"
        },
        "defaultValue": {
          "func": false,
          "value": "{}"
        }
      }
    ],
    "slots": [
      {
        "name": "default",
        "description": "Contents of the grid item"
      }
    ]
  },
  "KBreadcrumbs": {
    "exportName": "default",
    "displayName": "KBreadcrumbs",
    "description": "Used to aid deeply nested navigation of content channels, topics, and resources",
    "tags": {},
    "props": [
      {
        "name": "items",
        "description": "An array of objects, each with a `text` attribute (String) and a\n`link` attribute (vue router link object). The `link` attribute\nof the last item in the array is optional and ignored. The `link`\nattribute can be set to `null` which will render the breadcrumb only\nas text, regardless of its position in the breadcrumb.",
        "type": {
          "name": "array"
        },
        "required": true
      },
      {
        "name": "showSingleItem",
        "description": "By default, the breadcrums will be hidden when the length of items is 1.\nWhen set to `true`, a breadcrumb will be shown even when there is only one.",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      }
    ]
  },
  "KCheckbox": {
    "displayName": "KCheckbox",
    "description": "Used for toggling boolean user input",
    "tags": {},
    "exportName": "default",
    "props": [
      {
        "name": "label",
        "description": "Text label",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "showLabel",
        "description": "Whether or not to show the label",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "true"
        }
      },
      {
        "name": "checked",
        "description": "Checked state",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "indeterminate",
        "description": "Indeterminate state. Overrides `checked` state",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "disabled",
        "description": "Disabled state",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "description",
        "description": "Description - subtext to the label",
        "type": {
          "name": "string"
        },
        "required": false,
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      }
    ],
    "events": [
      {
        "name": "keydown"
      },
      {
        "name": "change",
        "description": "Emits change event",
        "type": {
          "names": [
            "undefined"
          ]
        },
        "properties": [
          {
            "type": {
              "names": [
                "undefined"
              ]
            },
            "name": "<anonymous1>"
          }
        ]
      },
      {
        "name": "blur",
        "description": "Emits blur event, useful for validation"
      }
    ],
    "methods": [
      {
        "name": "focus",
        "description": "Sets keyboard focus to the checkbox",
        "tags": {
          "access": [
            {
              "description": "public",
              "title": "access"
            }
          ]
        }
      }
    ],
    "slots": [
      {
        "name": "default",
        "description": "Optional slot as alternative to `label` prop"
      }
    ]
  },
  "KDateCalendar": {
    "displayName": "KDateCalendar",
    "exportName": "default",
    "description": "",
    "tags": {},
    "props": [
      {
        "name": "firstAllowedDate",
        "description": "constrains the selection to after this date, disabling dates prior",
        "type": {
          "name": "date"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "lastAllowedDate",
        "description": "constrains date selection to before this date, disabling dates after",
        "type": {
          "name": "date"
        },
        "defaultValue": {
          "func": false,
          "value": "new Date()"
        }
      },
      {
        "name": "selectedStartDate",
        "description": "default value of selected start date",
        "type": {
          "name": "date|null"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "selectedEndDate",
        "description": "default value of selected end date",
        "type": {
          "name": "date|null"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "previousMonthText",
        "description": "label for previous month button",
        "type": {
          "name": "string"
        },
        "required": true
      },
      {
        "name": "nextMonthText",
        "description": "label for next month button",
        "type": {
          "name": "string"
        },
        "required": true
      }
    ],
    "events": [
      {
        "name": "updateSelectedDates",
        "type": {
          "names": [
            "undefined"
          ]
        }
      }
    ]
  },
  "KDateDay": {
    "displayName": "KDateDay",
    "exportName": "default",
    "description": "",
    "tags": {},
    "props": [
      {
        "name": "day",
        "type": {
          "name": "number"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "isSelected",
        "type": {
          "name": "boolean"
        }
      },
      {
        "name": "isInRange",
        "type": {
          "name": "boolean"
        }
      },
      {
        "name": "isDisabled",
        "type": {
          "name": "boolean"
        }
      },
      {
        "name": "isEndOfWeek",
        "type": {
          "name": "boolean"
        }
      },
      {
        "name": "isStartOfWeek",
        "type": {
          "name": "boolean"
        }
      },
      {
        "name": "isLastDay",
        "type": {
          "name": "boolean"
        }
      },
      {
        "name": "activeMonth",
        "type": {
          "name": "number"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      }
    ]
  },
  "KDateInput": {
    "displayName": "KDateInput",
    "exportName": "default",
    "description": "",
    "tags": {},
    "props": [
      {
        "name": "inputRef",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "legendText",
        "type": {
          "name": "string"
        },
        "required": true
      },
      {
        "name": "errorMessage",
        "type": {
          "name": "string|boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "value",
        "type": {
          "name": "date|string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      }
    ],
    "events": [
      {
        "name": "updateDate",
        "type": {
          "names": [
            "undefined"
          ]
        }
      }
    ]
  },
  "KDropdownMenu": {
    "displayName": "KDropdownMenu",
    "description": "The KDropdownMenu component is used to contain multiple actions",
    "tags": {},
    "exportName": "default",
    "props": [
      {
        "name": "options",
        "description": "An array of options objects, with one object per dropdown item",
        "type": {
          "name": "array"
        },
        "required": true
      },
      {
        "name": "hasIcons",
        "description": "Whether or not the options display an icon",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "position",
        "description": "The position of the dropdown relative to the button",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "'bottom right'"
        },
        "values": [
          "bottom left",
          "bottom center",
          "bottom right",
          "top left",
          "top center",
          "top right",
          "left top",
          "left middle",
          "left bottom",
          "right top",
          "right middle",
          "right bottom"
        ]
      }
    ],
    "events": [
      {
        "name": "tab",
        "type": {
          "names": [
            "undefined"
          ]
        }
      },
      {
        "name": "select",
        "description": "Emitted when an option is selected",
        "type": {
          "names": [
            "undefined"
          ]
        }
      },
      {
        "name": "close"
      }
    ]
  },
  "KEmptyPlaceholder": {
    "displayName": "KEmptyPlaceholder",
    "exportName": "default",
    "description": "",
    "tags": {}
  },
  "KLabeledIcon": {
    "displayName": "KLabeledIcon",
    "exportName": "default",
    "description": "",
    "tags": {},
    "props": [
      {
        "name": "label",
        "description": "Text label",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "icon",
        "description": "An icon that will be prepended to the label. Uses the same icon names as the `KIcon` component",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "iconAfter",
        "description": "An icon that will be appended to the label. Uses the same icon names as the `KIcon` component",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "color",
        "description": "If provided, sets the color of the label and any icons that are provided",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "maxWidth",
        "description": "Limits label width to this value",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "'100%'"
        }
      }
    ],
    "slots": [
      {
        "name": "icon",
        "description": "Optional slot as alternative to `icon` prop"
      },
      {
        "name": "default",
        "description": "Optional slot as alternative to `label` prop"
      },
      {
        "name": "iconAfter",
        "description": "Optional slot as alternative to `iconAfter` prop"
      }
    ]
  },
  "KModal": {
    "exportName": "default",
    "displayName": "KModal",
    "description": "Used to focus attention on a singular action/task",
    "tags": {},
    "props": [
      {
        "name": "title",
        "description": "The title of the modal",
        "type": {
          "name": "string"
        },
        "required": true
      },
      {
        "name": "submitText",
        "description": "If provided, text of the submit button",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "cancelText",
        "description": "If provided, text of the cancel button",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "submitDisabled",
        "description": "Disable the submit button",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "cancelDisabled",
        "description": "Disable the cancel button",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "size",
        "description": "Width of modal. For consistency use the strings `'small'`, `'medium'`, or `'large'`.\nFor more precise control use an integer number of pixels.",
        "type": {
          "name": "string|number"
        },
        "defaultValue": {
          "func": false,
          "value": "'medium'"
        }
      },
      {
        "name": "hasError",
        "description": "Toggles error message indicator in title",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "errorMessage",
        "type": {
          "name": "string"
        },
        "required": false,
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      }
    ],
    "events": [
      {
        "name": "cancel",
        "description": "Emitted when the cancel button is clicked or the esc key is pressed"
      },
      {
        "name": "submit",
        "description": "Emitted when the submit button or the enter key is pressed"
      }
    ],
    "slots": [
      {
        "name": "default",
        "description": "Main content of modal"
      },
      {
        "name": "actions",
        "description": "Alternative buttons and actions below main content"
      }
    ]
  },
  "KOptionalText": {
    "displayName": "KOptionalText",
    "exportName": "default",
    "description": "",
    "tags": {},
    "props": [
      {
        "name": "text",
        "description": "Text to display. If the text is missing or empty, then `KEmptyPlaceholder` will be rendered",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "appearanceOverrides",
        "description": "If provided, sets the styles of the text",
        "type": {
          "name": "object|string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      }
    ],
    "slots": [
      {
        "name": "default",
        "description": "Pass sub-components to render, if none of the nodes in the entire node hierarchy contain text, then the `KEmptyPlaceholder` component will be rendered"
      }
    ]
  },
  "KPageContainer": {
    "exportName": "default",
    "displayName": "KPageContainer",
    "description": "",
    "tags": {},
    "props": [
      {
        "name": "noPadding",
        "description": "Whether or not to disable internal container padding",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "topMargin",
        "description": "Value in pixels for top margin",
        "type": {
          "name": "number"
        },
        "defaultValue": {
          "func": false,
          "value": "24"
        }
      }
    ],
    "slots": [
      {
        "name": "default",
        "description": "Contents of the page container"
      }
    ]
  },
  "KRadioButton": {
    "displayName": "KRadioButton",
    "description": "Used to display all options",
    "tags": {},
    "exportName": "default",
    "props": [
      {
        "name": "label",
        "description": "Text label",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "showLabel",
        "description": "Whether or not to show the label",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "true"
        }
      },
      {
        "name": "v-model",
        "description": "Component `data` with which to associate this radio button and its siblings",
        "type": {
          "name": "string|number|boolean"
        },
        "required": true
      },
      {
        "name": "buttonValue",
        "description": "Unique value that will be assigned to `v-model` data when this radio button is selected",
        "type": {
          "name": "string|number|boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "value",
        "description": "(DEPRECATED)",
        "type": {
          "name": "string|number|boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "description",
        "description": "If provided, description underneath label text",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "disabled",
        "description": "Whether or not the field is disabled",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "autofocus",
        "description": "Whether or not to auto-focus on mount",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "truncateLabel",
        "description": "Whether or not to truncate label",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      }
    ],
    "events": [
      {
        "name": "keydown",
        "description": "Emitted with `keydown` events",
        "type": {
          "names": [
            "undefined"
          ]
        }
      },
      {
        "name": "change",
        "description": "Emitted on each change with new boolean of button state",
        "type": {
          "names": [
            "undefined"
          ]
        },
        "properties": [
          {
            "type": {
              "names": [
                "undefined"
              ]
            },
            "name": "<anonymous1>"
          }
        ]
      },
      {
        "name": "input",
        "description": "Used to set `buttonValue` to `v-model` when checked",
        "type": {
          "names": [
            "undefined"
          ]
        }
      },
      {
        "name": "blur",
        "description": "Emits blur event, useful for validation"
      }
    ],
    "methods": [
      {
        "name": "focus",
        "description": "Puts keyboard focus on the radiobutton",
        "tags": {
          "access": [
            {
              "description": "public",
              "title": "access"
            }
          ]
        }
      }
    ],
    "slots": [
      {
        "name": "default",
        "description": "Optional slot as alternative to `label` prop"
      }
    ]
  },
  "KResponsiveElementMixin": {
    "exportName": "default",
    "displayName": "KResponsiveElementMixin",
    "description": "",
    "tags": {}
  },
  "KResponsiveWindowMixin": {
    "exportName": "default",
    "displayName": "KResponsiveWindowMixin",
    "description": "",
    "tags": {}
  },
  "KeenUiSelect": {
    "displayName": "KeenUiSelect",
    "exportName": "default",
    "description": "",
    "tags": {},
    "props": [
      {
        "name": "name",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "value",
        "type": {
          "name": "string|number|object|array"
        },
        "required": true
      },
      {
        "name": "options",
        "type": {
          "name": "array"
        },
        "defaultValue": {
          "func": false,
          "value": "[]"
        }
      },
      {
        "name": "placeholder",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "''"
        }
      },
      {
        "name": "icon",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "iconPosition",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "'left'"
        }
      },
      {
        "name": "label",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "floatingLabel",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "type",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "'basic'"
        }
      },
      {
        "name": "multiple",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "multipleDelimiter",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "', '"
        }
      },
      {
        "name": "hasSearch",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "searchPlaceholder",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "'Search'"
        }
      },
      {
        "name": "filter",
        "type": {
          "name": "func"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "disableFilter",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "loading",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "noResults",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "noResultsText",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "''"
        }
      },
      {
        "name": "keys",
        "type": {
          "name": "object"
        },
        "defaultValue": {
          "func": false,
          "value": "config.data.UiSelect.keys"
        }
      },
      {
        "name": "invalid",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "help",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "error",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "disabled",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "clearable",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "clearText",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "''"
        }
      }
    ],
    "events": [
      {
        "name": "dropdown-open"
      },
      {
        "name": "dropdown-close"
      },
      {
        "name": "query-change",
        "type": {
          "names": [
            "undefined"
          ]
        }
      },
      {
        "name": "input",
        "type": {
          "names": [
            "undefined"
          ]
        }
      },
      {
        "name": "change",
        "type": {
          "names": [
            "undefined"
          ]
        }
      },
      {
        "name": "select",
        "type": {
          "names": [
            "undefined"
          ]
        },
        "properties": [
          {
            "type": {
              "names": [
                "undefined"
              ]
            },
            "name": "<anonymous1>"
          }
        ]
      },
      {
        "name": "touch"
      },
      {
        "name": "focus",
        "type": {
          "names": [
            "undefined"
          ]
        }
      },
      {
        "name": "blur",
        "type": {
          "names": [
            "undefined"
          ]
        }
      }
    ],
    "methods": [
      {
        "name": "reset",
        "tags": {
          "access": [
            {
              "description": "public",
              "title": "access"
            }
          ]
        }
      }
    ],
    "slots": [
      {
        "name": "icon"
      },
      {
        "name": "default"
      },
      {
        "name": "display"
      },
      {
        "name": "option",
        "scoped": true,
        "bindings": [
          {
            "name": "highlighted",
            "title": "binding"
          },
          {
            "name": "index",
            "title": "binding"
          },
          {
            "name": "option",
            "title": "binding"
          },
          {
            "name": "selected",
            "title": "binding"
          }
        ]
      },
      {
        "name": "no-results"
      },
      {
        "name": "error"
      },
      {
        "name": "help"
      }
    ]
  },
  "KeenUiSelectOption": {
    "displayName": "KeenUiSelectOption",
    "exportName": "default",
    "description": "",
    "tags": {},
    "props": [
      {
        "name": "option",
        "type": {
          "name": "string|object"
        },
        "required": true
      },
      {
        "name": "type",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "'basic'"
        }
      },
      {
        "name": "multiple",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "highlighted",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "selected",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "keys",
        "type": {
          "name": "object"
        },
        "defaultValue": {
          "func": false,
          "value": "{\n  label: 'label',\n  image: 'image',\n}"
        }
      }
    ],
    "slots": [
      {
        "name": "default"
      }
    ]
  },
  "KSwitch": {
    "displayName": "KSwitch",
    "exportName": "default",
    "description": "",
    "tags": {},
    "props": [
      {
        "name": "value",
        "description": "Current value of the switch state: on or off",
        "type": {
          "name": "boolean"
        },
        "required": true
      },
      {
        "name": "name",
        "description": "does this need to be exposed?",
        "tags": {
          "ignore": [
            {
              "description": true,
              "title": "ignore"
            }
          ]
        },
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "label",
        "description": "If provided, show a text label next to the switch",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "tabindex",
        "description": "does this need to be exposed?",
        "tags": {
          "ignore": [
            {
              "description": true,
              "title": "ignore"
            }
          ]
        },
        "type": {
          "name": "string|number"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "trueValue",
        "description": "might not be used",
        "tags": {
          "ignore": [
            {
              "description": true,
              "title": "ignore"
            }
          ]
        },
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "true"
        }
      },
      {
        "name": "falseValue",
        "description": "might not be used",
        "tags": {
          "ignore": [
            {
              "description": true,
              "title": "ignore"
            }
          ]
        },
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "submittedValue",
        "description": "might not be used",
        "tags": {
          "ignore": [
            {
              "description": true,
              "title": "ignore"
            }
          ]
        },
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "'on'"
        }
      },
      {
        "name": "checked",
        "description": "seems redundant with 'value'",
        "tags": {
          "ignore": [
            {
              "description": true,
              "title": "ignore"
            }
          ]
        },
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "color",
        "description": "not used",
        "tags": {
          "ignore": [
            {
              "description": true,
              "title": "ignore"
            }
          ]
        },
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "'primary'"
        }
      },
      {
        "name": "switchPosition",
        "description": "not used",
        "tags": {
          "ignore": [
            {
              "description": true,
              "title": "ignore"
            }
          ]
        },
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "'left'"
        }
      },
      {
        "name": "disabled",
        "description": "Whether or not the switch is disabled",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      }
    ],
    "events": [
      {
        "name": "input",
        "type": {
          "names": [
            "undefined"
          ]
        },
        "description": "Emitted on each change with new `value`",
        "properties": [
          {
            "type": {
              "names": [
                "undefined"
              ]
            },
            "name": "<anonymous1>"
          }
        ]
      },
      {
        "name": "change",
        "description": "does this need to be exposed?",
        "type": {
          "names": [
            "undefined"
          ]
        },
        "tags": [
          {
            "title": "ignore",
            "content": true
          }
        ],
        "properties": [
          {
            "type": {
              "names": [
                "undefined"
              ]
            },
            "name": "<anonymous1>"
          }
        ]
      },
      {
        "name": "focus",
        "type": {
          "names": [
            "undefined"
          ]
        }
      },
      {
        "name": "blur",
        "type": {
          "names": [
            "undefined"
          ]
        }
      }
    ],
    "slots": [
      {
        "name": "default"
      }
    ]
  },
  "KTextTruncator": {
    "displayName": "KTextTruncator",
    "description": "Truncates text to a certain number of lines\nand adds an ellipsis character \"…\"\n\nInternet Explorer note:\nDepending on length of words of the text, there might\nbe a gap between the last visible word and \"…\"",
    "tags": {},
    "exportName": "default",
    "props": [
      {
        "name": "text",
        "description": "Text to be truncated",
        "type": {
          "name": "string"
        },
        "required": true
      },
      {
        "name": "maxLines",
        "description": "Maximum number of lines to be shown",
        "type": {
          "name": "number"
        },
        "required": false,
        "defaultValue": {
          "func": false,
          "value": "1"
        }
      },
      {
        "name": "lineHeightIE",
        "description": "Text line height in rem.\nUsed only for Internet Explorer fallback.",
        "type": {
          "name": "number"
        },
        "required": false,
        "defaultValue": {
          "func": false,
          "value": "1.4"
        }
      }
    ]
  },
  "KTransition": {
    "displayName": "KTransition",
    "description": "Exposes predefined set of transitions\nbuilt on top of Vue's <transition>",
    "tags": {},
    "exportName": "default",
    "props": [
      {
        "name": "kind",
        "description": "Transition kind. Can be one of:\n`'component-fade-out-in'`.",
        "type": {
          "name": "string"
        },
        "required": true
      }
    ],
    "slots": [
      {
        "name": "default"
      }
    ]
  },
  "KCircularLoader": {
    "displayName": "KCircularLoader",
    "description": "Used to show indeterminate loading",
    "tags": {},
    "exportName": "default",
    "props": [
      {
        "name": "type",
        "description": "One of `'determinate'` or `'indeterminate'`. Determinate loaders represent a known completion percentage, while indeterminate loaders simply show that activity is currently happening.",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "'indeterminate'"
        }
      },
      {
        "name": "shouldShow",
        "description": "Whether the loader should be displayed or not. It needs to be used instead of `v-if/v-show` for `minVisibleTime` to work.",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "true"
        }
      },
      {
        "name": "progress",
        "description": "For determinate loaders, value between 0 and 100 representing percentage completion",
        "type": {
          "name": "number"
        },
        "defaultValue": {
          "func": false,
          "value": "0"
        }
      },
      {
        "name": "delay",
        "description": "Whether there should be a delay before the loader displays. Useful if the action often takes less than a second or two.",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "minVisibleTime",
        "description": "Do not hide the loader until `minVisibleTime` in milliseconds. Useful to avoid jarring UX when the actions finishes very fast. In comparison to `delay`, `minVisibleTime` emphasizes that an action associated with the loader is indeed taking place. `shouldShow` prop needs to be used instead of `v-if/v-show` for this to work.",
        "type": {
          "name": "number"
        },
        "defaultValue": {
          "func": false,
          "value": "0"
        }
      },
      {
        "name": "size",
        "description": "Overall size of the loader in pixels",
        "type": {
          "name": "number"
        },
        "defaultValue": {
          "func": false,
          "value": "32"
        }
      },
      {
        "name": "stroke",
        "description": "Stroke width of the loader in pixels",
        "type": {
          "name": "number"
        },
        "defaultValue": {
          "func": false,
          "value": "4"
        }
      },
      {
        "name": "disableDefaultTransition",
        "description": "Disables the default fade transition. Disabling is suitable when using\na loader in tandem with another component (e.g. as part of v-if/v-else)\nas we typically need to wrap both components in a single transition.\nHaving a loader wrapped by its own transition can cause glitches in\nsuch situations.",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      }
    ]
  },
  "KLinearLoader": {
    "displayName": "KLinearLoader",
    "description": "Used to show determinate or indeterminate loading",
    "tags": {},
    "exportName": "default",
    "props": [
      {
        "name": "type",
        "description": "One of `'determinate'` or `'indeterminate'`. Determinate loaders represent a known completion percentage, while indeterminate loaders simply show that activity is currently happening.",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "'indeterminate'"
        }
      },
      {
        "name": "progress",
        "description": "For determinate loaders, value between 0 and 100 representing percentage completion",
        "type": {
          "name": "number"
        },
        "defaultValue": {
          "func": false,
          "value": "0"
        }
      },
      {
        "name": "delay",
        "description": "Whether there should be a delay before the loader displays. Useful if the action often takes less than a second or two.",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      }
    ]
  },
  "KTabs": {
    "exportName": "default",
    "displayName": "KTabs",
    "description": "Displays tabs.",
    "tags": {},
    "props": [
      {
        "name": "tabs",
        "mixin": {
          "name": "tabsMixin",
          "path": "tabsMixin.js"
        },
        "description": "An array of tab objects `{ id, label, to }` where `id` and `label`\nproperties are required and `to` is optional.\nWhen `to` is provided, tabs render as router links.\nOtherwise, they render as buttons.",
        "type": {
          "name": "array"
        },
        "required": true
      },
      {
        "name": "ariaLabel",
        "mixin": {
          "name": "tabsMixin",
          "path": "tabsMixin.js"
        },
        "description": "A label that describes the purpose of the set of tabs.\nProviding either `ariaLabel` or `ariaLabelledBy`\nis required.",
        "type": {
          "name": "string"
        },
        "required": false,
        "defaultValue": {
          "func": false,
          "value": "''"
        }
      },
      {
        "name": "ariaLabelledBy",
        "mixin": {
          "name": "tabsMixin",
          "path": "tabsMixin.js"
        },
        "description": "ID reference to a DOM element which provides a label\nthat describes the purpose of the set of tabs.\nProviding either `ariaLabel` or `ariaLabelledBy`\nis required.",
        "type": {
          "name": "string"
        },
        "required": false,
        "defaultValue": {
          "func": false,
          "value": "''"
        }
      },
      {
        "name": "color",
        "mixin": {
          "name": "tabsMixin",
          "path": "tabsMixin.js"
        },
        "description": "Tabs text color.\nDefaults to `$themeTokens.annotation`.",
        "type": {
          "name": "string"
        },
        "required": false,
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "colorActive",
        "mixin": {
          "name": "tabsMixin",
          "path": "tabsMixin.js"
        },
        "description": "Text color of an active tab.\nDefaults to `$themeTokens.primary`.",
        "type": {
          "name": "string"
        },
        "required": false,
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "backgroundColor",
        "mixin": {
          "name": "tabsMixin",
          "path": "tabsMixin.js"
        },
        "description": "Tabs background color.\nDefaults to `$themeTokens.surface`.",
        "type": {
          "name": "string"
        },
        "required": false,
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "hoverBackgroundColor",
        "mixin": {
          "name": "tabsMixin",
          "path": "tabsMixin.js"
        },
        "description": "Tabs hover background color.\nDefaults to `$themePalette.grey.v_300`.",
        "type": {
          "name": "string"
        },
        "required": false,
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "appearanceOverrides",
        "mixin": {
          "name": "tabsMixin",
          "path": "tabsMixin.js"
        },
        "description": "Tabs styles that complement or override default styles\nor styles defined via props (will be sent to `$computedClass`,\nwhich means that styles that are accepted by `$computedClass`,\ne.g. pseudo-classes, are supported)",
        "type": {
          "name": "object"
        },
        "required": false,
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "appearanceOverridesActive",
        "mixin": {
          "name": "tabsMixin",
          "path": "tabsMixin.js"
        },
        "description": "An active tab styles that complement or override default styles\nor styles defined via props (will be sent to `$computedClass`,\nwhich means that styles that are accepted by `$computedClass`,\ne.g. pseudo-classes, are supported)",
        "type": {
          "name": "object"
        },
        "required": false,
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "enablePrint",
        "mixin": {
          "name": "tabsMixin",
          "path": "tabsMixin.js"
        },
        "description": "Tab list items are hidden when printing by default.\n`enablePrint` set to `true` makes them visible in print mode.",
        "type": {
          "name": "boolean"
        },
        "required": false,
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "tabsId",
        "description": "An ID of a tabbed interface represented\nby this component.\nNeeds to be be unique in regards to all\ntabbed interfaces rendered on one page.",
        "type": {
          "name": "string"
        },
        "required": true
      }
    ],
    "slots": [
      {
        "name": "tab",
        "scoped": true,
        "description": "Optional slot for tab labels. Exposes `tab` object and `isActive` boolean.",
        "bindings": [
          {
            "name": "tab",
            "title": "binding"
          },
          {
            "name": "isActive",
            "title": "binding"
          }
        ]
      },
      {
        "name": "default",
        "description": "An alternative to using slots named by tabs' IDs."
      },
      {
        "name": "slot",
        "scoped": true,
        "bindings": [
          {
            "name": "name",
            "title": "binding"
          }
        ]
      }
    ]
  },
  "KTabsList": {
    "exportName": "default",
    "displayName": "KTabsList",
    "description": "Displays the tab list of a tabbed interface.\nIt is meant to be used together with `KTabsPanel`.\nTabs can be buttons or router links.\n\nTabs are implemented to be manually activated as described in\nhttps://www.w3.org/WAI/ARIA/apg/example-index/tabs/tabs-manual.html",
    "tags": {},
    "props": [
      {
        "name": "tabs",
        "mixin": {
          "name": "tabsMixin",
          "path": "tabsMixin.js"
        },
        "description": "An array of tab objects `{ id, label, to }` where `id` and `label`\nproperties are required and `to` is optional.\nWhen `to` is provided, tabs render as router links.\nOtherwise, they render as buttons.",
        "type": {
          "name": "array"
        },
        "required": true
      },
      {
        "name": "ariaLabel",
        "mixin": {
          "name": "tabsMixin",
          "path": "tabsMixin.js"
        },
        "description": "A label that describes the purpose of the set of tabs.\nProviding either `ariaLabel` or `ariaLabelledBy`\nis required.",
        "type": {
          "name": "string"
        },
        "required": false,
        "defaultValue": {
          "func": false,
          "value": "''"
        }
      },
      {
        "name": "ariaLabelledBy",
        "mixin": {
          "name": "tabsMixin",
          "path": "tabsMixin.js"
        },
        "description": "ID reference to a DOM element which provides a label\nthat describes the purpose of the set of tabs.\nProviding either `ariaLabel` or `ariaLabelledBy`\nis required.",
        "type": {
          "name": "string"
        },
        "required": false,
        "defaultValue": {
          "func": false,
          "value": "''"
        }
      },
      {
        "name": "color",
        "mixin": {
          "name": "tabsMixin",
          "path": "tabsMixin.js"
        },
        "description": "Tabs text color.\nDefaults to `$themeTokens.annotation`.",
        "type": {
          "name": "string"
        },
        "required": false,
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "colorActive",
        "mixin": {
          "name": "tabsMixin",
          "path": "tabsMixin.js"
        },
        "description": "Text color of an active tab.\nDefaults to `$themeTokens.primary`.",
        "type": {
          "name": "string"
        },
        "required": false,
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "backgroundColor",
        "mixin": {
          "name": "tabsMixin",
          "path": "tabsMixin.js"
        },
        "description": "Tabs background color.\nDefaults to `$themeTokens.surface`.",
        "type": {
          "name": "string"
        },
        "required": false,
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "hoverBackgroundColor",
        "mixin": {
          "name": "tabsMixin",
          "path": "tabsMixin.js"
        },
        "description": "Tabs hover background color.\nDefaults to `$themePalette.grey.v_300`.",
        "type": {
          "name": "string"
        },
        "required": false,
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "appearanceOverrides",
        "mixin": {
          "name": "tabsMixin",
          "path": "tabsMixin.js"
        },
        "description": "Tabs styles that complement or override default styles\nor styles defined via props (will be sent to `$computedClass`,\nwhich means that styles that are accepted by `$computedClass`,\ne.g. pseudo-classes, are supported)",
        "type": {
          "name": "object"
        },
        "required": false,
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "appearanceOverridesActive",
        "mixin": {
          "name": "tabsMixin",
          "path": "tabsMixin.js"
        },
        "description": "An active tab styles that complement or override default styles\nor styles defined via props (will be sent to `$computedClass`,\nwhich means that styles that are accepted by `$computedClass`,\ne.g. pseudo-classes, are supported)",
        "type": {
          "name": "object"
        },
        "required": false,
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "enablePrint",
        "mixin": {
          "name": "tabsMixin",
          "path": "tabsMixin.js"
        },
        "description": "Tab list items are hidden when printing by default.\n`enablePrint` set to `true` makes them visible in print mode.",
        "type": {
          "name": "boolean"
        },
        "required": false,
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "tabsId",
        "description": "An ID of a tabbed interface that this component is part of.\nNeeds to be be unique in regards to all tabbed interfaces\nrendered on one page.",
        "type": {
          "name": "string"
        },
        "required": true
      },
      {
        "name": "v-model",
        "description": "An ID of an active tab.",
        "type": {
          "name": "string"
        },
        "required": true
      }
    ],
    "events": [
      {
        "name": "activate",
        "description": "Emitted when a tab is activated. Its payload is the active tab ID.",
        "type": {
          "names": [
            "undefined"
          ]
        }
      },
      {
        "name": "click",
        "description": "Emitted when a tab is clicked. Its payload is the active tab ID.\nWhen compared to the `activate` event, `click` is emitted only when\na user is interacting with tabs, whereas `activate` can be emitted\nprogramatically in addition to user interaction.",
        "type": {
          "names": [
            "undefined"
          ]
        }
      }
    ],
    "methods": [
      {
        "name": "focusActiveTab",
        "description": "Puts focus on the active tab",
        "tags": {
          "access": [
            {
              "description": "public",
              "title": "access"
            }
          ]
        }
      }
    ],
    "slots": [
      {
        "name": "tab",
        "scoped": true,
        "description": "Optional slot for tab labels. Exposes `tab` object and `isActive` boolean.",
        "bindings": [
          {
            "name": "tab",
            "title": "binding"
          },
          {
            "name": "isActive",
            "title": "binding"
          }
        ]
      }
    ]
  },
  "KTabsPanel": {
    "displayName": "KTabsPanel",
    "description": "A part of a tabbed interface that displays\ncontent associated with the active tab.\nIt is meant to be used together with `KTabsList`.",
    "tags": {},
    "exportName": "default",
    "props": [
      {
        "name": "tabsId",
        "description": "An ID of a tabbed interface that this component is part of.\nNeeds to be be unique in regards to all tabbed interfaces\nrendered on one page.",
        "type": {
          "name": "string"
        },
        "required": true
      },
      {
        "name": "activeTabId",
        "description": "An ID of an active tab.",
        "type": {
          "name": "string"
        },
        "required": true
      }
    ],
    "slots": [
      {
        "name": "default",
        "description": "An alternative to using slots named by tabs' IDs."
      },
      {
        "name": "[activeTabId]",
        "scoped": true,
        "description": "Slots named by tab's IDs. Only content corresponding to the active tab is displayed.",
        "bindings": [
          {
            "name": "name",
            "title": "binding"
          }
        ]
      }
    ]
  },
  "KDateRange": {
    "exportName": "default",
    "displayName": "KDateRange",
    "description": "",
    "tags": {},
    "props": [
      {
        "name": "firstAllowedDate",
        "description": "Constrains the selection to after this date, disabling dates prior",
        "type": {
          "name": "date"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "lastAllowedDate",
        "description": "Constrains date selection to before this date, disabling dates after",
        "type": {
          "name": "date"
        },
        "defaultValue": {
          "func": false,
          "value": "new Date()"
        }
      },
      {
        "name": "defaultStartDate",
        "description": "Default value of start date",
        "type": {
          "name": "date"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "defaultEndDate",
        "description": "Default value of end date",
        "type": {
          "name": "date"
        },
        "defaultValue": {
          "func": true,
          "value": "function() {\n  return startOfToday();\n}"
        }
      },
      {
        "name": "submitText",
        "description": "Submission text of modal",
        "type": {
          "name": "string"
        },
        "required": true
      },
      {
        "name": "cancelText",
        "description": "Cancellation text of modal",
        "type": {
          "name": "string"
        },
        "required": true
      },
      {
        "name": "title",
        "description": "Title of modal",
        "type": {
          "name": "string"
        },
        "required": true
      },
      {
        "name": "description",
        "description": "Description of modal",
        "type": {
          "name": "string|null"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "startDateLegendText",
        "description": "Start date input label",
        "type": {
          "name": "string"
        },
        "required": true
      },
      {
        "name": "endDateLegendText",
        "description": "End date input label",
        "type": {
          "name": "string"
        },
        "required": true
      },
      {
        "name": "previousMonthText",
        "description": "label for previous month button",
        "type": {
          "name": "string"
        },
        "required": true
      },
      {
        "name": "nextMonthText",
        "description": "label for next month button",
        "type": {
          "name": "string"
        },
        "required": true
      }
    ],
    "events": [
      {
        "name": "cancel"
      },
      {
        "name": "submit",
        "description": "Emitted when the submit button or the enter key is pressed",
        "type": {
          "names": [
            "undefined"
          ]
        }
      }
    ],
    "slots": [
      {
        "name": "description",
        "description": "Description of modal"
      }
    ]
  },
  "KIcon": {
    "displayName": "KIcon",
    "exportName": "default",
    "description": "",
    "tags": {},
    "props": [
      {
        "name": "icon",
        "description": "Icon token identifier",
        "type": {
          "name": "string"
        },
        "required": true
      },
      {
        "name": "color",
        "description": "Color to apply to the icon",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "disableColor",
        "description": "Don't apply automatic fill, allowing external styling.\nCurrently used by the design system itself. Not exposed until we see a broader need",
        "tags": {
          "ignore": [
            {
              "description": true,
              "title": "ignore"
            }
          ]
        },
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      }
    ]
  },
  "KImg": {
    "displayName": "KImg",
    "exportName": "default",
    "description": "",
    "tags": {},
    "props": [
      {
        "name": "src",
        "description": "Sets the image path",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "altText",
        "description": "Alternate text for the image. This is required and will throw a warning when it's not provided (empty) unless isDecorative is true",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "''"
        }
      },
      {
        "name": "isDecorative",
        "description": "Sets the image as decorative. This sets the alt image property to an empty string.",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "height",
        "description": "Sets the height for the component",
        "type": {
          "name": "number|string"
        },
        "defaultValue": {
          "func": false,
          "value": "undefined"
        }
      },
      {
        "name": "width",
        "description": "Sets the width for the component",
        "type": {
          "name": "number|string"
        },
        "defaultValue": {
          "func": false,
          "value": "undefined"
        }
      },
      {
        "name": "maxHeight",
        "description": "Sets the maximum height for the component",
        "type": {
          "name": "number|string"
        },
        "defaultValue": {
          "func": false,
          "value": "undefined"
        }
      },
      {
        "name": "minHeight",
        "description": "Sets the minimum height for the component",
        "type": {
          "name": "number|string"
        },
        "defaultValue": {
          "func": false,
          "value": "undefined"
        }
      },
      {
        "name": "maxWidth",
        "description": "Sets the maximum width for the component",
        "type": {
          "name": "number|string"
        },
        "defaultValue": {
          "func": false,
          "value": "undefined"
        }
      },
      {
        "name": "minWidth",
        "description": "Sets the minimum width for the component",
        "type": {
          "name": "number|string"
        },
        "defaultValue": {
          "func": false,
          "value": "undefined"
        }
      },
      {
        "name": "appearanceOverrides",
        "description": "Accepts a Vue dynamic styles object to override the default styles to modify the appearance of the component.\nIt's attributes always take precedence over any specified styling (internal component's styles, styles calculated from props etc.)",
        "type": {
          "name": "object"
        },
        "defaultValue": {
          "func": false,
          "value": "{}"
        }
      }
    ],
    "events": [
      {
        "name": "error",
        "description": "Emitted when the image fails to load. The DOM event that triggered the error is available in the payload.",
        "type": {
          "names": [
            "undefined"
          ]
        }
      }
    ],
    "slots": [
      {
        "name": "default"
      }
    ]
  },
  "KLogo": {
    "displayName": "KLogo",
    "exportName": "default",
    "description": "",
    "tags": {},
    "props": [
      {
        "name": "altText",
        "description": "Alternative text for the logo",
        "type": {
          "name": "string"
        },
        "required": true,
        "defaultValue": {
          "func": false,
          "value": "''"
        }
      },
      {
        "name": "height",
        "description": "Sets the height for the logo",
        "type": {
          "name": "number|string"
        },
        "defaultValue": {
          "func": false,
          "value": "undefined"
        }
      },
      {
        "name": "width",
        "description": "Sets the width for the logo",
        "type": {
          "name": "number|string"
        },
        "defaultValue": {
          "func": false,
          "value": "undefined"
        }
      },
      {
        "name": "maxHeight",
        "description": "Sets the maximum height for the logo",
        "type": {
          "name": "number|string"
        },
        "defaultValue": {
          "func": false,
          "value": "undefined"
        }
      },
      {
        "name": "minHeight",
        "description": "Sets the minimum height for the logo",
        "type": {
          "name": "number|string"
        },
        "defaultValue": {
          "func": false,
          "value": "undefined"
        }
      },
      {
        "name": "maxWidth",
        "description": "Sets the maximum width for the logo",
        "type": {
          "name": "number|string"
        },
        "defaultValue": {
          "func": false,
          "value": "undefined"
        }
      },
      {
        "name": "minWidth",
        "description": "Sets the minimum width for the logo",
        "type": {
          "name": "number|string"
        },
        "defaultValue": {
          "func": false,
          "value": "undefined"
        }
      }
    ]
  },
  "KSelect": {
    "displayName": "KSelect",
    "description": "Used to select or filter items",
    "tags": {},
    "exportName": "default",
    "props": [
      {
        "name": "value",
        "description": "Object currently selected",
        "type": {
          "name": "object"
        },
        "required": true
      },
      {
        "name": "options",
        "description": "Array of option objects { value, label, disabled }.\nDisabled key is optional",
        "type": {
          "name": "array"
        },
        "required": true
      },
      {
        "name": "label",
        "description": "Label",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "disabled",
        "description": "Whether disabled or not",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "invalid",
        "description": "Whether invalid or not",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "invalidText",
        "description": "Text displayed if invalid",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "inline",
        "description": "Whether or not display as inline block",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "floatingLabel",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "true"
        }
      },
      {
        "name": "placeholder",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "clearable",
        "description": "Whether to turn into a clearable state\nwhen an option has been selected.",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "clearText",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "''"
        }
      }
    ],
    "events": [
      {
        "name": "blur"
      },
      {
        "name": "change",
        "type": {
          "names": [
            "undefined"
          ]
        }
      },
      {
        "name": "select",
        "type": {
          "names": [
            "undefined"
          ]
        },
        "properties": [
          {
            "type": {
              "names": [
                "undefined"
              ]
            },
            "name": "<anonymous1>"
          }
        ]
      }
    ],
    "slots": [
      {
        "name": "display"
      },
      {
        "name": "option",
        "scoped": true,
        "bindings": [
          {
            "name": "highlighted",
            "title": "binding"
          },
          {
            "name": "index",
            "title": "binding"
          },
          {
            "name": "option",
            "title": "binding"
          },
          {
            "name": "selected",
            "title": "binding"
          }
        ]
      }
    ]
  },
  "KTextbox": {
    "displayName": "KTextbox",
    "description": "Handles user input.",
    "tags": {},
    "exportName": "default",
    "props": [
      {
        "name": "label",
        "description": "Label for the text field",
        "type": {
          "name": "string"
        },
        "required": true
      },
      {
        "name": "value",
        "description": "Value of the text field",
        "type": {
          "name": "string|number"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "invalid",
        "description": "Whether or not the current `value` is invalid",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "invalidText",
        "description": "Text conditionally displayed based on values of `invalid` and `showInvalidText`",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "showInvalidText",
        "description": "Show the `invalidText` even if the user has not focused or change the input.\n`invalid` must also be `true` for this to take effect.",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "disabled",
        "description": "Whether or not the field is disabled",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "autofocus",
        "description": "Whether or not to autofocus",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "maxlength",
        "description": "Maximum number of characters for `value`",
        "type": {
          "name": "number"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "autocomplete",
        "description": "HTML5 autocomplete attribute (`off`, `on`, `name`, `username`, `current-password`, etc)",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "autocapitalize",
        "description": "HTML5 autocapitalize attribute. Used for touch-input enabled UI (`off`, `on`, `words`, etc)",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "type",
        "description": "HTML5 type of input (`text`, `password`, `number`, etc.)",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "'text'"
        }
      },
      {
        "name": "min",
        "description": "Minimum value (when `value` type is `number`)",
        "type": {
          "name": "number"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "max",
        "description": "Maximum value (when `value` type is `number`)",
        "type": {
          "name": "number"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "textArea",
        "description": "Whether to display as a multi-line text area",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "floatingLabel",
        "description": "Whether or not to display as a floating label.\nThis should not actually be used",
        "tags": {
          "ignore": [
            {
              "description": true,
              "title": "ignore"
            }
          ]
        },
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "true"
        }
      }
    ],
    "events": [
      {
        "name": "input",
        "description": "Emitted on each change with new `value`",
        "type": {
          "names": [
            "undefined"
          ]
        }
      },
      {
        "name": "keydown",
        "description": "Emitted with `keydown` events",
        "type": {
          "names": [
            "undefined"
          ]
        }
      },
      {
        "name": "blur",
        "type": {
          "names": [
            "undefined"
          ]
        }
      },
      {
        "name": "focus",
        "type": {
          "names": [
            "undefined"
          ]
        }
      }
    ],
    "methods": [
      {
        "name": "focus",
        "description": "Puts keyboard focus in the text field",
        "tags": {
          "access": [
            {
              "description": "public",
              "title": "access"
            }
          ]
        }
      }
    ]
  },
  "KTooltip": {
    "displayName": "KTooltip",
    "description": "Used to create a tooltip.",
    "tags": {},
    "exportName": "default",
    "props": [
      {
        "name": "reference",
        "description": "Name of `ref` element within the parent's `$refs` object. Tooltip will be\npositioned relative to this element.",
        "type": {
          "name": "string"
        },
        "required": true
      },
      {
        "name": "refs",
        "description": "Parent's `$refs` object which should contain the named `reference`.",
        "type": {
          "name": "object"
        },
        "required": true
      },
      {
        "name": "disabled",
        "description": "Whether or not tooltip is disabled",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "placement",
        "description": "Placement of tooltip relative to `reference`. Supports any _popper.js_ placement string",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "'bottom'"
        }
      }
    ],
    "slots": [
      {
        "name": "default",
        "description": "Text of the tooltip"
      }
    ]
  }
}